
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.153.526L5.42 3.259a.774.774 0 000 1.094c.3.3.791.302 1.093 0l1.414-1.414-.002 5.287-5.286.001 1.414-1.414a.774.774 0 000-1.093.774.774 0 00-1.094 0L.226 8.454a.774.774 0 000 1.093l2.733 2.733a.774.774 0 001.093-1.093L2.638 9.771l5.289.004.003 5.288-1.416-1.416a.774.774 0 00-1.093 0 .774.774 0 000 1.094l2.734 2.733c.3.3.791.302 1.093 0l2.733-2.733a.774.774 0 00-1.093-1.094l-1.414 1.414.002-5.286 5.286-.001-1.414 1.413a.774.774 0 000 1.094c.301.3.792.301 1.094 0l2.733-2.734a.774.774 0 000-1.093L14.441 5.72a.774.774 0 00-1.094 0 .774.774 0 000 1.094l1.416 1.416-5.289-.004-.003-5.29 1.416 1.417c.3.3.791.302 1.093 0a.775.775 0 000-1.094L9.247.526a.774.774 0 00-1.094 0z"}})])
          )
        }
      }
    